import type { Breadcrumb } from '@/types';

export const findInNestedByName = (tree: Breadcrumb[], name: string): any => {
  if (!tree) {
    return;
  }

  for (const element of tree) {
    if (element.name === name) {
      return [element];
    }

    const a = findInNestedByName(element.children as Breadcrumb[], name);
    if (a) {
      a.unshift(element);
      return a;
    }
  }

  return null;
};
